import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {Config} from "../Config";

export default function Organization(prop) {

    let [data, setData] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getOrganization();

                if(prop !== null && prop.lang === 'en') {
                    resView.title = resView.title_en;
                    resView.detail = resView.detail_en;
                }

                setData(resView);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getOrganization() {
        const response = await fetch(Config.apiUrl +'organization/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'About Us':'เกี่ยวกับ ศชวซ.'} / {prop.lang === 'en' ? 'Organization':'โครงสร้างคณะทำงาน ศชวซ.'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Organization':'โครงสร้างคณะทำงาน ศชวซ.'}</span>
                    </h1>
                </div>
            </div>

            <div className="section bg-light">
                <div className="container">
                    <div className="news-details" data-aos="fade-in">
                        <h2 className="text-center text-primary">{data?.title}</h2>
                        <div className="article">
                            <div dangerouslySetInnerHTML={{__html: data?.detail}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 